export default __webpack_public_path__ + "static/media/arrow-right-red-2.58cba00d.svg";